import { createContext, useContext } from 'react';

interface CardContextProps {
  isFavorite: boolean;
  setIsFavorite: (value: boolean) => void;
}

export const CardContext = createContext<CardContextProps>({
  isFavorite: false,
  setIsFavorite: () => undefined,
});

export const useCardContext = () => useContext(CardContext);
